function initPage5(vm, self) {
	vm.listWardfourthLA = [];
	vm.listWardthirdLA = [];
	vm.listDistrictfourthLA = [];
	vm.listDistrictthirdLA = [];
	vm.popupDateOfBirthThirdLA = false;
	vm.popupDateOfBirthFourthLA = false;
	vm.districtthirdLA = "";
	vm.districtfourthLA = "";
	vm.provincethirdLA = "";
	vm.provincefourthLA = "";

	vm.invalidTab5 = function() {
		self.clearMessage();
		var hasError = false;
		if (vm.proposal !== undefined && !vm.proposal.checkAllDisable) {
			for (var i = 0; i < vm.checkIDNumPage5.length; i++) {
				if (vm.checkIDNumPage5[i] == -1) {
					if (i == 0) {
						if (vm.proposal.laList[2].customer.idNum !== undefined
								&& vm.proposal.laList[2].customer.idNum !== null
								&& vm.proposal.laList[2].customer.idNum !== '') {
							var name = '';
							if (vm.proposal.laList[2].customer.lastName !== null
									&& vm.proposal.laList[2].customer.lastName !== '')
								name = vm.proposal.laList[2].customer.lastName
										+ ' ';
							if (vm.proposal.laList[2].customer.firstName !== null
									&& vm.proposal.laList[2].customer.firstName !== '')
								name = vm.proposal.laList[2].customer.firstName;
							if (name != undefined && name != null && name != '') {
								self.addAlert("CMND/Khai sinh số khách hàng [" + name
										+ "] chưa được kiểm tra.", 'danger');
							} else {
								self
										.addAlert(
												'Vui lòng nhập họ tên người bảo hiểm bổ sung 2',
												'danger');
							}
							hasError = true;
						}
					} else if (i == 1) {
						if (vm.proposal.laList[3].customer !== null
								&& vm.proposal.laList[3].customer.idNum !== undefined
								&& vm.proposal.laList[3].customer.idNum !== null
								&& vm.proposal.laList[3].customer.idNum !== '') {
							var name = '';
							if (vm.proposal.laList[3].customer.lastName !== null
									&& vm.proposal.laList[3].customer.lastName !== '')
								name = vm.proposal.laList[3].customer.lastName
										+ ' ';
							if (vm.proposal.laList[3].customer.firstName !== null
									&& vm.proposal.laList[3].customer.firstName !== '')
								name = vm.proposal.laList[3].customer.firstName;
							if (name != undefined && name != null && name != '') {
								self.addAlert("CMND/Khai sinh số khách hàng [" + name
										+ "] chưa được kiểm tra.", 'danger');
							} else {
								self
										.addAlert(
												'Vui lòng nhập họ tên người bảo hiểm bổ sung 3',
												'danger');
							}
							hasError = true;
						}
					}
				}
			}
			for (var i = 0; i < vm.checkNameAgeSexPage5.length; i++) {
				if (vm.checkNameAgeSexPage5[i] == -1) {
					if (i == 0) {
						if (vm.proposal.laList[2].customer.idNum !== undefined
								&& vm.proposal.laList[2].customer.idNum !== null
								&& vm.proposal.laList[2].customer.idNum !== '') {
							var name = '';
							if (vm.proposal.laList[2].customer.lastName !== null
									&& vm.proposal.laList[2].customer.lastName !== '')
								name = vm.proposal.laList[2].customer.lastName
										+ ' ';
							if (vm.proposal.laList[2].customer.firstName !== null
									&& vm.proposal.laList[2].customer.firstName !== '')
								name = vm.proposal.laList[2].customer.firstName;
							if (name != undefined && name != null && name != '') {
								self.addAlert("Tuổi khách hàng [" + name
										+ "] chưa được kiểm tra.", 'danger');
							} else {
								self
										.addAlert(
												'Vui lòng nhập họ tên người bảo hiểm bổ sung 2',
												'danger');
							}
							hasError = true;
						}
					} else if (i == 1) {
						if (vm.proposal.laList[3].customer !== null
								&& vm.proposal.laList[3].customer.idNum !== undefined
								&& vm.proposal.laList[3].customer.idNum !== null
								&& vm.proposal.laList[3].customer.idNum !== '') {
							var name = '';
							if (vm.proposal.laList[3].customer.lastName !== null
									&& vm.proposal.laList[3].customer.lastName !== '')
								name = vm.proposal.laList[3].customer.lastName
										+ ' ';
							if (vm.proposal.laList[3].customer.firstName !== null
									&& vm.proposal.laList[3].customer.firstName !== '')
								name = vm.proposal.laList[3].customer.firstName;
							if (name != undefined && name != null && name != '') {
								self.addAlert("Tuổi khách hàng [" + name
										+ "] chưa được kiểm tra.", 'danger');
							} else {
								self
										.addAlert(
												'Vui lòng nhập họ tên người bảo hiểm bổ sung 3',
												'danger');
							}
							hasError = true;
						}
					}
				}
			}
		}
		if (!hasError)
			hasError = vm.validateAllRequired(false);
		return hasError;
	};
}

function setThirdLAInfo(vm, result) {
	angular.copy(result, vm.proposal.laList[2].customer);
	vm.proposal.laList[2].customer.birthCountryCode = result.birthCountryCode;
	vm.proposal.laList[2].customer.nationality = result.nationality;
	vm.proposal.laList[2].customer.dob = result.clientBirthDate;
	vm.calculaNumberYear(1, vm.proposal.laList[2].customer.dob, 4);
	vm.proposal.laList[2].customer.locationCode = result.locationCode;
	vm.proposal.laList[2].customer.residentCountryCode = result.residentCountryCode;
	// anc
	vm.provincethirdLA = result.provinceCode;
	vm.getDistrict(vm.provincethirdLA, 6);
	vm.districtthirdLA = result.districtCode;
	vm.getWard(vm.districtthirdLA, 6);
}

function setFourthLAInfo(vm, result) {
	angular.copy(result, vm.proposal.laList[3].customer);
	vm.proposal.laList[3].customer.birthCountryCode = result.birthCountryCode;
	vm.proposal.laList[3].customer.nationality = result.nationality;
	vm.proposal.laList[3].customer.dob = result.clientBirthDate;
	vm.calculaNumberYear(1, vm.proposal.laList[3].customer.dob, 5);
	vm.proposal.laList[3].customer.locationCode = result.locationCode;
	vm.proposal.laList[3].customer.residentCountryCode = result.residentCountryCode;
	// anc
	vm.provincefourthLA = result.provinceCode;
	vm.getDistrict(vm.provincefourthLA, 7);
	vm.districtfourthLA = result.districtCode;
	vm.getWard(vm.districtfourthLA, 7);
}
